import { memo, ReactNode } from "react";

import styles from "./style.module.scss";

export const PopperPortal = memo<{ children: ReactNode | ReactNode[] }>(({ children }) => {
  return (
    <>
      {children}
      <div id="popperPortal" className={styles.root} />
    </>
  );
});

export default PopperPortal;
